import { render } from "./AppAlert.vue?vue&type=template&id=64b2a068"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__